import React, { startTransition } from 'react';
import TxtViewerClass from './txtViewerclass';
import PreviewBase from './previewbase';
import DocxViewer from './docxviewer';

class PreviewDOCX extends PreviewBase
{


constructor (props)
{
    super(props);
    this.olddatas = "";

}



componentDidMount()
{
    super.componentDidMount();
}                                                                                    
componentDidUpdate()
{
    super.componentDidUpdate();

}

componentWillUnmount()
{
    super.componentWillUnmount();
}



setFile(datas)
{
    this.setState({datas: datas})
}



render()
{

    return(
        <>
        <DocxViewer blob={this.state.datas} />
        </>
    )


    

}

}
export default PreviewDOCX;

